<template>
	<div>
		<div class="rolelist">
			<el-row>
				<el-col :span="19"><handlerbutton :handlerlist="handlerbtn" @buttonhandle="buttonhandle"></handlerbutton></el-col>
				<el-col :span="5">
					<el-input v-model="searchkey" @keyup.enter.native="refreshgrid" placeholder="按角色名称搜索" size="small" class="input-with-select">
						<!-- <el-button slot="append" size="mini">搜索</el-button> -->
					</el-input>
				</el-col>
			</el-row>
			<el-row style="height:10px;"></el-row>
			<el-row>
				<el-col :span="24">
					<tableui style="width:100%;" v-loading="loading" editcell="0" ref="rolelisttable" :tableData="rolelist" :columns="columns" @gridhandle="gridhandle" :gridheight="gridheight"></tableui>
				</el-col>
				<el-col>共{{ count }}条数据</el-col>
			</el-row>
		</div>
		<el-dialog
			:visible.sync="showuserwin"
			title="设置用户"
			width="50%"
			:close-on-click-modal="false"
			lock-scroll
			:modal-append-to-body="false"
			:show-close="true"
		>
			<setuserrole ref="userwin" :rolename="rolename"></setuserrole>
		</el-dialog>
	</div>
</template>

<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import setuserrole from '@/components/user/setuserrole.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui,
		handlerbutton,
		setuserrole
	},
	data() {
		return {
			searchkey: '',
			columns: [
				{ field: 'r_name', title: '角色名称', type: 'text', width: '120', sortable: false },
				{
					field: '',
					title: '操作',
					type: 'template',
					width: '400',
					sortable: false,
					template: [
						{ type: 'button', title: '修改权限', icon: 'el-icon-edit-outline', handletype: 'success', event: 'editrole' },
						{ type: 'button', title: '增减人员', icon: 'el-icon-s-custom', handletype: 'primary', event: 'setuser' },
						{ type: 'button', title: '删除', icon: 'el-icon-delete', handletype: 'danger', event: 'delrole' }
					]
				}
			],
			rolelist: [],
			count: 0,
			pagecount: 1,
			gridheight: (window.innerHeight * 74) / 100 + 'px',
			loading: false,
			handlerbtn: [],
			showuserwin:false,
			rolename:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/user/rolelist.scss');
		});
		this.GetHanlderBtn();
		this.refreshgrid();
		this.$tool.setgridstyle(this.$refs.rolelisttable,0);
		var that=this;
		Utils.$on('refreshgrid', function(msg) {
			that.refreshgrid();
		});	
	},
	methods: {
		//获取操作按钮权限
		async GetHanlderBtn() {
			var that = this;
			this.$apipost.get.GetUserPermession({ type: '3', parentid: '16', mode: '用户管理' }).then(res => {
				that.handlerbtn = res.linklist;
			});
		},
		refreshgrid() {
			var that = this;
			this.loading = true;
			this.$apipost.get.GetRoleList({ search: this.searchkey }).then(res => {
				this.loading = false;
				that.rolelist = res.list;
				that.count = res.count;
			});
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			if (e.event == 'addrole') {
				this.addrole();
			}
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			if (e.event == 'editrole') {
				this.editrole(e);
			}
			if (e.event == 'delrole') {
				this.delrole(e);
			}
			if (e.event == 'setuser') {
				this.setuser(e);
			}
		},
		//添加角色
		addrole() {
			Utils.$emit('go',{l_url:'/user/addrole',l_name:'新增角色',l_id:'17',urlparam:{ty:'list'}});
		},
		//编辑角色
		editrole(e) {
			Utils.$emit('go',{l_url:'/user/addrole',l_name:'修改角色',l_id:'修改角色',urlparam:{ty:'list',rolename:escape(this.rolelist[e.index].r_name)}});		
		},
		//用户增减人员
		setuser(e){
			//弹窗选择人员
			this.showuserwin=true;
			if(this.$refs.userwin!=undefined){
				this.$refs.userwin.init({ rolename: this.rolelist[e.index].r_name});
			}
			else{
				this.rolename=this.rolelist[e.index].r_name;
			}
		},
		delrole(e){
			var that = this;
			this.$confirm('确定删除此角色吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal:false
			})
				.then(() => {
					this.$apipost.post.DelRole({ rolename: this.rolelist[e.index].r_name }).then(res => {
						if (res.state == '1') {
							this.$tool.message('删除成功', 1);
							that.refreshgrid();
						} else {
							this.$tool.message(res.message, 0);
						}
					});
				})
				.catch(() => {});
		}
	}
};
</script>
